import React from 'react';

import styled from 'styled-components';
import {fadeIn, fadeIn2, fadeInT} from "../../../styled/StyledComponent";

interface BannerProps {
    children?: React.ReactNode;
    img:any;
    width:any;
    height:number;
    url?:any;
}

const Banner:React.FC<BannerProps> = ({img, width, height, children, url}) => {

return(
  <Container className={"banner"} url={url || ""} style={{width:width, }}>
    {/*<img src={img} alt="" />*/}
    {children}
  </Container>
)

}
export { Banner };

const Container = styled.div<{url:any}>`
    max-width: 1048px;
    margin-bottom: 26px;
    position: relative;
    animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    background-image: url(${props => props.url});
    border-radius: 20px;
    overflow: hidden;
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
    height: 220px;
    //img {
    //    position: absolute;
    //    width: 100%;
    //    height: 100%;
    //    display: block;
    // 
    //    z-index: 0;
    //}
    border-radius: 20px;
    overflow: hidden;
`;